// extracted by mini-css-extract-plugin
export default {"fill-in-gaps__word-item":"Word_fill-in-gaps__word-item__dl1hU"};